module.exports = __webpack_public_path__ + "static/media/weather.284db4ad.png";